import { put, select, takeEvery } from 'redux-saga/effects';
import { getServiceProvider, IServiceProvider } from '../../../services';
import { commonActions } from '../../common';
import actions from '../actions';
import selectors from '../selectors';

const requestReviewSaga = takeEvery(actions.requestReview.request.type, function* () {
  const serviceProvider: IServiceProvider = yield getServiceProvider();

  const tourCode: string = yield select(selectors.selectTourCode);

  try {
    yield serviceProvider.api.requestReview(tourCode);
    yield put(actions.requestReview.success());
    yield put(
      commonActions.showSnackbar({
        key: 'create_tour.visibility.public.requested_review_success',
      })
    );
  } catch (e) {
    yield put(actions.requestReview.failure(e));
    serviceProvider.analyticsService.logError(e);
  }
});

const sagas = [requestReviewSaga];
export default sagas;
